

export const LegalNotice = ()=> {
    return null;
}